module.exports = __webpack_public_path__ + "img/txt_01.2fa7cb7b.png";